export const minimumMultiViewContentHeight = 50; // px.
